export class QueryGetMaterialDTO 
{
    PackageTypeId: number;
    TransportModeId: number;
}

